import { atom } from 'jotai'

import { type FormattedDispatchRow } from '@/features/vehicle-dispatch-boards'

/**
 * ドラッグ中にマウスの下にある実績作成済みの行
 */
export const dragOverDispatchAtom = atom<FormattedDispatchRow | null>(null)

dragOverDispatchAtom.debugLabel = 'dragOverDispatchAtom'
